<template>
    <div class="d-inline">
        <button v-on:click="openModal" type="button" class="btn btn-sm btn-secondary-outline">
            <i class="material-icons">edit</i></button>
    </div>
</template>
<script>
import _ from 'lodash';
import Vuex from 'vuex';

export default {
    data() {
        return {

        }
    },

    props: ['content', 'config', 'addNotification'],

    components: {

    },

    computed: {
        endpoint() {
            return window.location.origin + '/api' + _.get(this.content, 'link', '');
        },
    },

    watch: {

    },

    methods: {
        ...Vuex.mapActions('sub', [
            'setStatus',
            'getInitialData',
        ]),

        openModal() {
            this.getInitialData(this.endpoint);
            this.setStatus(true);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/FormModalEditButtonComponent.vue